export const LINK_STAGE = {
  ALPHA: 'ALPHA',
  BETA: 'BETA',
  STABLE: 'STABLE',
};

export const LINK_STATUS = {
  PENDING_DEVICE_REGISTRATION: 'PENDING_DEVICE_REGISTRATION',
  PARTIALLY_REGISTERED: 'PARTIALLY_REGISTERED',
  FAIL: 'FAIL',
  PENDING: 'PENDING',
  INACTIVE: 'INACTIVE',
  UPDATING_ASSETS: 'UPDATING_ASSETS',
  UPDATING_TRANSACTIONS: 'UPDATING_TRANSACTIONS',
  ACTIVE: 'ACTIVE',
  RETRIES: 'RETRIES',
  REQUESTED: 'REQUESTED',
  UNAUTHORIZED: 'UNAUTHORIZED',
};

export const LINK_MODE = {
  MANUAL: 'MANUAL',
  AUTOMATIC: 'AUTOMATIC',
  CASH: 'CASH',
  EMAIL: 'EMAIL',
  READ_ONLY: 'READ_ONLY',
};

export const LINK_QUEUED_STATUS = {
  READY: 'READY',
  QUEUED: 'QUEUED',
  FAILED: 'FAILED',
};

export const PRE_LINK_STATUS = {
  REQUESTED: 'REQUESTED',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
};

export const SYNC_LINK_STATUS_LIST = [
  { value: 'COMPLETED' },
  { value: 'IN_PROGRESS' },
  { value: 'PENDING' },
  { value: 'FAILED' },
];

export const LINK_STATUS_PENDING_ASSETS = ['PENDING', 'UPDATING_ASSETS'];
export const LINK_STATUS_PENDINGS = ['PENDING', 'UPDATING_ASSETS', 'UPDATING_TRANSACTIONS'];

export const LINK_ERRORS = {
  403: {
    actions: ['contact-us', 'cancel'],
  },
  418: {
    actions: ['contact-us', 'cancel'],
  },
  501: {
    actions: ['contact-us', 'cancel'],
  },
  503: {
    actions: ['try-later'],
  },
  RETRIES: {
    message: 'The maximum waiting time has elapsed, refresh the page or contact your administrator.',
    actions: ['retry', 'cancel'],
  },
  DEFAULT: {
    actions: ['retry', 'cancel'],
  },
};

export const LINK_ERROR_ACTION = {
  RETRY: 'retry',
  CANCEL: 'cancel',
  TRY_LATER: 'try-later',
  CONTACT_US: 'contact-us',
};

export const SYNC_LINK_STATUS = {
  REQUESTED: 'REQUESTED',
  PENDING: 'PENDING',
  IN_PROGRESS: 'IN_PROGRESS',
  PROCESSED: 'PROCESSED',
  FAILED: 'FAILED',
};

export const LINK_OTP_PROVIDER = {
  PROPRIETOR: 'PROPRIETOR',
  GOOGLE_AUTHENTICATOR: 'GOOGLE_AUTHENTICATOR',
};
